import { render } from "./page-footer-component.vue?vue&type=template&id=378b7344&scoped=true"
import script from "./page-footer-component.vue?vue&type=script&lang=js"
export * from "./page-footer-component.vue?vue&type=script&lang=js"

import "./page-footer-component.vue?vue&type=style&index=0&id=378b7344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-378b7344"]])

export default __exports__